import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { DismissibleTooltip } from '@/shared/components/DismissibleTooltip';
import { useFirstPurchaseDiscount } from '@/shared/hooks/useFirstPurchaseDiscount';
const SNOOZE_COOKIE_KEY = 'first_purchase_tooltip_snoozed';

/** 툴팁을 표시하지 않을 페이지 경로 */
const HIDDEN_PATHS = ['/pricing', '/checkout'];
interface FirstPurchaseTooltipProps {
  children: React.ReactNode;
}

/**
 * 첫 구매 프로모션 툴팁
 *
 * - 로그인: useFirstPurchaseDiscount (availability API) 기반
 * - 비로그인: usePrices의 activePromotion (pricing API) 기반
 * - Pricing 페이지 이외에서만 노출
 * - Pricing 진입 시 자동 숨김 (스누즈 안 됨)
 * - X 클릭 시 7일동안 스누즈 (쿠키 자동 만료)
 */
export function FirstPurchaseTooltip({
  children
}: FirstPurchaseTooltipProps) {
  const {
    t
  } = useTranslation(['common']);
  const {
    isEligible,
    discountRate
  } = useFirstPurchaseDiscount();
  const router = useRouter();
  const isHiddenPage = HIDDEN_PATHS.some(path => router.pathname.startsWith(path));
  const eligible = isEligible && !isHiddenPage;
  const label = `${t('common:discount.firstPurchaseBenefit')} ${discountRate * 100}%`;
  return <DismissibleTooltip eligible={eligible} cookieKey={SNOOZE_COOKIE_KEY} content={label} data-sentry-element="DismissibleTooltip" data-sentry-component="FirstPurchaseTooltip" data-sentry-source-file="FirstPurchaseTooltip.tsx">
      {children}
    </DismissibleTooltip>;
}